import type { AppModule } from '@ohmybible/core';

import * as routes from './routes';

/** The Bible reader (`/text-bible`): registered in every build, production included. */
export const ReaderModule: AppModule = { routes };
